module.exports = __webpack_public_path__ + "static/media/Sizex_Clin.cde55eeb.png";